<template>
  <base-dialog
    @save-item="saveItem"
    dialogId="edit-portal-options-dialog"
    :open.sync="openDialog"
    :form-ref.sync="portalOptionFormRef"
    :loading.sync="isLoading"
  >
    <template v-slot:[`dialog.title`]>
      <span>Paramètres techniques du portail</span>
    </template>
    <template v-slot:[`dialog.content`]>
      <v-container>
        <v-text-field
          label="Nom du template"
          v-model="portalOptionsForm.name"
          :rules="nameRules"
        ></v-text-field>
        <v-text-field
          label="TVA"
          :rules="vatRules"
          v-model="portalOptionsForm.vat"
        ></v-text-field>
        <v-select
          v-model="portalOptionsForm.basicProfile"
          label="Basic Profile"
          required
          :items="profiles"
          item-text="label"
          item-value="id"
        ></v-select>
        <v-select
          v-model="portalOptionsForm.fullProfile"
          label="Full Profile"
          required
          :items="profiles"
          item-text="label"
          item-value="id"
        ></v-select>
        <v-select
          v-model="portalOptionsForm.freeCardModel"
          label="Free Card Model"
          required
          :items="cardModels"
          item-text="description"
          item-value="id"
        ></v-select>
        <v-checkbox
          v-model="portalOptionsForm.activateSsl"
          label="Activer SSL"
          persistent-hint
        ></v-checkbox>
      </v-container>
    </template>
    <template v-slot:[`dialog.actions.save`]>Mettre à jour</template>
  </base-dialog>
</template>
<script>
import { onMounted, toRefs, watch, computed } from "@vue/composition-api";
import { usePortalOptions } from "@/composables/portal-options";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    portalOptions: Object,
    cardModels: Array,
    profiles: Array,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { updatePortalOptions, portalOptionData } = usePortalOptions();

    /* Variables */
    const {
      name,
      vat,
      freeCardModel,
      basicProfile,
      fullProfile,
      activateSsl,
    } = props.portalOptions;

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await updatePortalOptions(props.portalOptions);
      openDialog.value = false;
    };

    /* Cycle de vie */
    onMounted(() => {
      portalOptionData.portalOptionsForm = {
        name,
        vat,
        freeCardModel,
        basicProfile,
        fullProfile,
        activateSsl,
      };
    });

    watch(
      () => portalOptionData.isUpdated,
      function (newValue) {
        if (newValue == true) {
          const po = portalOptionData.portalOptionsForm;
          po.id = props.portalOptions.id;
          emit("update:portalOptions", po);
        }
      }
    );
    return {
      updatePortalOptions,
      ...toRefs(portalOptionData),
      openDialog,
      saveItem,
    };
  },
};
</script>
